module.exports = __webpack_public_path__ + "img/opera.de286680.svg";